import { defineStyleConfig } from '@chakra-ui/react'
import { asChakraVariable } from '~/themes/colors/colors'

// import { asChakraVariable }  from '~/themes/colors/colors'

export enum KbdVariants {
  Mango = 'mango',
}

export const KbdStyle = defineStyleConfig({
  variants: {
    [KbdVariants.Mango]: {
      minWidth: '1.875rem',
      width: 'auto',
      height: '1.875rem',
      padding: '0.5rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '0.5rem',
      marginRight: '0.5rem',
      boxShadow: `0px 1px 2px ${asChakraVariable('mask.gray.700.40')}, 0px 2px 6px ${asChakraVariable('mask.gray.700.20')}`,
      background: `linear-gradient(to bottom, ${asChakraVariable('gray.100')} 0%, ${asChakraVariable('gray.200')} 50%, ${asChakraVariable('gray.200')} 51%, ${asChakraVariable('gray.100')} 100%)`,
    },
  },
})
